
import { getPostApi } from "../../../../callApi/postApi";
import CustomHeader from "../../../../components/admin/CustomHeader";
import CustomLeftBar from "../../../../components/admin/CustomLeftBar";
import CustomPagination from "../../../../components/admin/CustomPagination";
import React, { useEffect, useState } from "react";
import { format } from "date-fns";
import { useNavigate } from "react-router-dom";
export default function AdminPostKnowledge() {
  const [nowPage, setnowPage] = useState(1);
  const [allPage, setallPage] = useState(1);
  const [AllData, setAllData] = useState([1, 2, 3, 4, 5, 6, 7]);
  const [PostData, setPostData] = useState(null)
  const router = useNavigate()
  useEffect(() => {
    CallPost()
  }, [])
  const CallPost = async () =>{
    let res = await getPostApi({
      limit:10,
      page:nowPage,
      post_categories_id:2
    })
    if(res.status == 200){
      setPostData(res.data.data.post)
      setallPage(Math.ceil(res?.data?.data?.count/8))
    }
  }
  return (
    <div className="flex flex-col h-screen">
      <CustomHeader />
      <div className="flex flex-row flex-[1] overflow-hidden">
        <CustomLeftBar page="Posts" subPage="News & Event" />
        <div className="p-8 flex flex-col items-center flex-[1] overflow-y-auto">
          <p className=" text-[24px] w-full font-semibold">
            ข่าวและกิจกรรมทั้งหมด
          </p>
          <div className="overflow-x-auto w-full flex-[1] my-5">
            <div className="min-w-[500px]  ">
              <div className="flex flex-row border">
                <div className="flex-[2] md:flex-[3] min-w-10 p-2  font-semibold">
                  ชื่อเรื่อง
                </div>
                <div className="flex-[1] min-w-10 p-2  font-semibold">
                  ผู้เขียน
                </div>
                <div className="flex-[1] min-w-10 p-2  font-semibold">
                  วันที่
                </div>
              </div>
              {PostData?.map((item, i) => {
                return (
                  <div
                    key={i}
                    className={
                      "flex flex-row border " + (i % 2 ? "" : "bg-[#F6F7F7]")
                    }
                    onClick={()=>{
                      router('/admin/post/'+item.id)
                    }}
                  >
                    <div className="flex-[2] md:flex-[3] min-w-10 p-2  font-medium cursor-pointer active:opacity-50 hover:opacity-80 text-[#2271B1]">
                      {item.title}
                    </div>
                    <div className="flex-[1] min-w-10 p-2 ">Admin</div>
                    <div className="flex-[1] min-w-10 p-2 ">
                      {item.created_at!=null?format(item.created_at,'yyy/MM/dd '+"'at'"+' HH.mm'):''}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          <CustomPagination
            now={nowPage}
            all={allPage}
            onChangePage={(page) => {
              setnowPage(page);
            }}
          />
        </div>
      </div>
    </div>
  );
}
